/* eslint-disable consistent-return */
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import addDays from 'date-fns/addDays';
import LeaseApplicationService from 'aurora-composition/services/leaseApplication';
import LeaseService from 'aurora-composition/services/leaseService';
import WorkflowService from 'aurora-composition/services/workflowService';
import DocumentService from 'aurora-composition/services/documentService';
import OwnerService from 'aurora-composition/services/ownerService';
import PropertiesService from 'aurora-composition/services/propertyService';
import history from 'aurora-utils/history';
import { flattenObject } from 'aurora-utils/utils';
import messages from 'aurora-translations';
import {
  CleverTapServicesPreValidation,
  CleverTapServicesLeaseRegistrationInitiateFlow,
  CleverTapServicesLeaseAmendmentInitiateFlow,
  CleverTapServicesLeaseRenewalInitiateFlow,
  CleverTapGenericServiceNextEvent,
  CleverTapGenericServiceNextSuccessEvent,
  CleverTapGenericServiceNextFailureEvent,
  CleverTapGenericServiceUploadDocumentEvent,
  CleverTapGenericServiceSubmitEvent,
  CleverTapGenericServiceSubmitSuccessEvent,
  CleverTapGenericServiceSubmitFailureEvent,
  CleverTapGenericServiceAddOccupantEvent,
  CleverTapValidatePremise,
  CleverTapServicesStartApplication,
} from 'aurora-utils/cleverTap.eventhelper';
import formatPreValidationForClevertap from 'aurora-utils/clevertap.validation.formatter';
import * as types from './constants';
import { fetchDocument, fetchPropertyDetail } from './application/actions';

const generalError = error => {
  const errorsContainingData = ['500045', '500046', '500047', '500002798', '500002799'];
  const date = error?.data?.result?.data?.date;

  const transformedError = errorsContainingData?.includes(error?.statusCode)
    ? {
        message: error?.message,
        statusCode: error?.statusCode,
        values: {
          date: moment(date, 'YYYY-MM-DD', true)?.isValid() ? moment(date, 'YYYY-MM-DD')?.format('DD/MM/YYYY') : '',
        },
      }
    : error?.message;

  return {
    type: types.GENERAL_LEASE_ERROR,
    payload: { error: transformedError },
  };
};

export const clearState = () => ({
  type: types.CLEAR_STATE,
});

export const initiateApplication = (key, workflowId, data, plotId) => async dispatch => {
  try {
    dispatch({ type: types.INITIATE_LEASE_APPLICATION });

    // if (key === 'registration') {
    const validationParams = {
      applicationType: workflowId,
      plotIds: [plotId],
    };
    const validation = await WorkflowService.checkValidation(validationParams);
    if (!isEmpty(validation?.result)) {
      CleverTapServicesPreValidation({
        property_id: plotId,
        application_type: workflowId,
        ...formatPreValidationForClevertap(validation?.result),
      });
      history.replace('/app/services/validations', { ...validation?.result });
    } else {
      CleverTapServicesPreValidation({
        property_id: plotId,
        application_type: workflowId,
      });
      CleverTapServicesStartApplication({
        property_id: plotId,
        application_type: workflowId,
      });
      const application = await WorkflowService.registerApplication(data);
      CleverTapServicesLeaseRegistrationInitiateFlow();
      const workflow = await WorkflowService.fetchWorkflow(workflowId);
      const property = await PropertiesService.fetchPropertyLease(plotId);
      // const onwaniAddressRes = await LeaseService.getOnwaniAddress(plotId);

      workflow?.result?.attributes
        ?.find(item => item.name === 'contractClassificationType')
        ?.values.push(
          {
            selected: false,
            id: 125385849115547,
            valueId: 'DiplomaticOffices',
            valueName: 'diplomat',
          },
          {
            selected: false,
            id: 125385849115548,
            valueId: 'Government',
            valueName: 'government',
          },
          {
            selected: false,
            id: 125385849115549,
            valueId: 'PublicBenefitAssociation',
            valueName: 'public_benefit_association',
          },
        );

      dispatch({
        type: types.INITIATE_LEASE_APPLICATION_SUCCESS,
        payload: { key, workflow, application, property },
      });
      history.push('/app/services/lease/registration/' + application?.result?.id);
    }
    // }
  } catch (error) {
    dispatch(generalError(error));
  }
};

export const initiateMultiUnitsApplication = (key, data) => async dispatch => {
  try {
    dispatch({ type: types.INITIATE_LEASE_APPLICATION });

    const validationParams = {
      applicationType: data?.applicationType,
      plotIds: data?.plotIds,
    };

    const validation = await WorkflowService.checkValidation(validationParams);
    if (!isEmpty(validation?.result)) {
      CleverTapServicesPreValidation({
        application_type: data?.applicationType,
        property_ids: data?.plotIds,
        ...formatPreValidationForClevertap(validation?.result),
      });
      history.replace('/app/services/lease/multi-units-validations', {
        data: validation?.result,
        // plotIds: data?.plotIds,
      });
      dispatch({
        type: types.INITIATE_LEASE_APPLICATION_FAILURE,
      });
    } else {
      CleverTapServicesPreValidation({
        application_type: data?.applicationType,
        property_ids: data?.plotIds,
      });
      CleverTapServicesStartApplication({
        application_type: data?.applicationType,
        property_ids: data?.plotIds,
      });

      const res = await WorkflowService.registerApplication(data);
      CleverTapServicesLeaseRegistrationInitiateFlow();

      const workflow = await WorkflowService.fetchWorkflow(data?.applicationType);
      workflow?.result?.attributes
        ?.find(item => item.name === 'contractClassificationType')
        ?.values.push(
          {
            selected: false,
            id: 125385849115547,
            valueId: 'DiplomaticOffices',
            valueName: 'diplomat',
          },
          {
            selected: false,
            id: 125385849115548,
            valueId: 'Government',
            valueName: 'government',
          },
          {
            selected: false,
            id: 125385849115549,
            valueId: 'PublicBenefitAssociation',
            valueName: 'public_benefit_association',
          },
        );

      dispatch({
        type: types.INITIATE_LEASE_MULTIPLE_APPLICATION_SUCCESS,
        payload: {
          key,
          workflow,
          applicationId: res?.result?.id,
          isMultipleUnits: res?.result?.multipleUnit,
        },
      });
      history.push('/app/services/lease/registration/' + res?.result?.id);
    }
  } catch (error) {
    dispatch(generalError(error));
  }
};

export const changeProperty = (property, contractId) => async dispatch => {
  dispatch({ type: types.CHANGE_LEASE_PROPERTY });
  history.push({
    pathname: '/app/services/lease/select-single-unit-property',
    state: { property, ...(contractId && { contractId }) },
  });
};

export const fetchWorkflow = (key, workflowId, stepKey) => async dispatch => {
  try {
    dispatch({ type: types.FETCH_LEASE_WORKFLOW });

    const workflow = await WorkflowService.fetchWorkflow(workflowId, stepKey);

    workflow?.result?.attributes
      ?.find(item => item.name === 'contractClassificationType')
      ?.values.push(
        {
          selected: false,
          id: 125385849115547,
          valueId: 'DiplomaticOffices',
          valueName: 'diplomat',
        },
        {
          selected: false,
          id: 125385849115548,
          valueId: 'Government',
          valueName: 'government',
        },
        {
          selected: false,
          id: 125385849115549,
          valueId: 'PublicBenefitAssociation',
          valueName: 'public_benefit_association',
        },
      );

    dispatch({
      type: types.FETCH_LEASE_WORKFLOW_SUCCESS,
      payload: { key, workflow },
    });
  } catch (error) {
    dispatch(generalError(error));
  }
};

export const fetchApplicationDetails = (
  workflow,
  appId,
  newDocuments = false,
  fetchPropertyDetails = false,
) => async dispatch => {
  try {
    let documents = [];
    dispatch({ type: types.FETCH_LEASE_APPLICATION_DETAILS });
    const application = await LeaseService.fetchApplicationDetails(appId);
    if (fetchPropertyDetails && application?.success && application?.result?.multipleUnit !== true) {
      const propertyDetail = await fetchPropertyDetail(application?.result?.property?.plotId);
      application.result.propertyDetails = propertyDetail;
    }
    if (newDocuments) {
      documents = await DocumentService.fetchApplicationDocuments({
        applicationId: appId,
      });
    }

    dispatch({
      type: types.FETCH_LEASE_APPLICATION_DETAILS_SUCCESS,
      payload: { workflow, application, documents },
    });
  } catch (error) {
    dispatch(generalError(error));
  }
};

export const fetchSuccessApplicationDetails = appId => async dispatch => {
  // eslint-disable-line
  try {
    dispatch({ type: types.FETCH_LEASE_APPLICATION_DETAILS });

    const res = await LeaseService.fetchApplicationDetails(appId);
    dispatch({ type: types.FETCH_LEASE_SUCCESS_APPLICATION_DETAILS_SUCCESS });

    return res;
  } catch (error) {
    dispatch(generalError(error));
    return error;
  }
};

export const addPrimaryLessor = payload => async dispatch => {
  try {
    dispatch({ type: types.ADD_LEASE_PRIMARY_LESSOR });

    const lessor = await LeaseService.addPrimaryLessor(payload);

    dispatch({ type: types.ADD_LEASE_PRIMARY_LESSOR_SUCCESS });

    return lessor;
  } catch (error) {
    dispatch(generalError(error));
    return error;
  }
};

// eslint-disable-next-line consistent-return
export const fetchPremise = (appId, premiseNumber, type = null, plotId) => async (dispatch, getState) => {
  const { leaseReducer } = getState();
  const payload = {
    premiseId: premiseNumber,
    applicationId: appId,
  };
  try {
    dispatch({ type: types.FETCH_PREMISE_DETAILS });
    // For single lease to get always first premise object
    const response = await LeaseService.fetchAllPremises({
      applicationId: appId,
      premiseNumber: [premiseNumber],
    });
    CleverTapValidatePremise({
      ...payload,
      applicationType: leaseReducer?.renewal?.applicationType,
      applicationStatus: leaseReducer?.renewal?.applicationStatus,
      applicationNumber: leaseReducer?.renewal?.applicationNumber,
      isSuccess: true,
    });

    dispatch({
      type: types.FETCH_PREMISE_DETAILS_SUCCESS,
      payload: { premise: response?.result[0], workflow: type, plotId },
    });
  } catch (error) {
    CleverTapValidatePremise({
      ...payload,
      applicationType: leaseReducer?.registration?.applicationType,
      applicationStatus: leaseReducer?.registration?.applicationStatus,
      applicationNumber: leaseReducer?.registration?.applicationNumber,
      isSuccess: false,
      errorMessage: error?.data?.result?.description || error?.message,
      errorCode: error?.data?.result?.statusCode || error?.statusCode,
    });

    dispatch({
      type: types.FETCH_PREMISE_DETAILS_ERROR,
      payload: { error: error?.data?.result?.description || error?.message },
    });
  }
};

export const fetchAllPremises = (appId, premises, workflow) => async dispatch => {
  try {
    dispatch({ type: types.FETCH_PREMISE_DETAILS });

    const res = await LeaseService.fetchAllPremises({
      applicationId: appId,
      premiseNumber: premises,
    });
    if (res?.success) {
      dispatch({
        type: types.FETCH_ALL_PREMISE_DETAILS_SUCCESS,
        payload: {
          premisesIds: premises,
          premisesRes: res?.result,
          workflow,
        },
      });
    }
    return res;
  } catch (error) {
    dispatch(generalError(error));
    return error;
  }
};

export const fetchPerson = (uid, params = null, leaseType) => async dispatch => {
  try {
    dispatch({ type: types.FETCH_PERSON_DETAILS });

    const person = await OwnerService.fetchUserById(uid, params);

    const tenantObject = {
      tenName: person?.result?.nameEn || null,
      tenNameAr: person?.result?.nameAr || null,
      tenPhone: person?.result?.phoneNumber || null,
      tenEmail: person?.result?.email || null,
      businessFlags: person?.result?.businessFlags || null,
    };

    dispatch({
      type: types.FETCH_PERSON_DETAILS_SUCCESS,
      payload: { person, tenantObject, leaseType },
    });
    return person;
  } catch (error) {
    dispatch(generalError(error));
    return error;
  }
};

export const fetchCompany = (tradeLicense, leaseType) => async dispatch => {
  try {
    dispatch({ type: types.FETCH_LEASE_COMPANY_DETAILS });

    const company = await OwnerService.fetchCompanyByLicense(tradeLicense);

    dispatch({
      type: types.FETCH_LEASE_COMPANY_DETAILS_SUCCESS,
      payload: { company, leaseType },
    });
  } catch (error) {
    dispatch(generalError(error));
  }
};

export const fetchReserve = (id, workflow = 'registration') => async dispatch => {
  try {
    dispatch({ type: types.FETCH_LEASE_RESERVE_DETAILS });

    const reserve = await OwnerService.fetchCompanyReserve(id);

    dispatch({
      type: types.FETCH_LEASE_RESERVE_DETAILS_SUCCESS,
      payload: { reserve, workflow },
    });
  } catch (error) {
    dispatch(generalError(error));
  }
};

export const changeForm = (workflow, data) => async dispatch => {
  dispatch({ type: types.CHANGE_LEASE_FORM, payload: { workflow, data } });
};

export const changeWorkflowStep = (workflow, step) => async dispatch => {
  dispatch({
    type: types.CHANGE_LEASE_WORKFLOW_STEP,
    payload: { workflow, step },
  });
};

export const addToError = message => async dispatch => {
  dispatch({ type: types.ADD_TO_LEASE_ERROR_INITITATE });

  setTimeout(() => {
    dispatch({ type: types.ADD_TO_LEASE_ERROR, payload: { message } });
  }, 200);
};

export const editOccupant = (workflow, data) => async (dispatch, getState) => {
  try {
    const isMultipleUnitsFlow = data?.isMultipleUnits;
    let payload = {};
    if (!isMultipleUnitsFlow) {
      payload = {
        applicationId: data.applicationId,
        occId: data.occId,
        occName: data.occName,
        occNameAr: data.occNameAr,
        ...(data.relationId && { relationId: data.relationId }),
        mobileNumber: data?.mobileNumber,
        email: data?.email,
        id: data?.id,
      };
    } else {
      payload = {
        applicationId: data?.applicationId,
        propertyId: data.propertyId,
        occupants: [
          {
            occId: data.occId,
            occName: data.occName,
            occNameAr: data.occNameAr,
            ...(data.relationId && { relationId: data.relationId }),
            mobileNumber: data?.mobileNumber,
            email: data?.email,
            id: data?.id,
          },
        ],
      };
    }
    const response = await LeaseService.addOccupant(payload);
    if (response?.success) {
      const occupantData = isMultipleUnitsFlow
        ? {
            occId: payload?.occupants?.[0]?.occId,
            occName: payload?.occupants?.[0]?.occName,
            occNameAr: payload?.occupants?.[0]?.occNameAr,
            ...(payload?.occupants?.[0]?.relationId && { relationId: payload?.occupants?.[0]?.relationId }),
            mobileNumber: payload?.occupants?.[0]?.mobileNumber,
            propertyId: payload?.propertyId,
            email: payload?.occupants?.[0]?.email,
            id: payload?.occupants?.[0]?.id,
          }
        : payload;
      const { leaseReducer } = getState();
      const {
        form: { occupants },
      } = leaseReducer?.[workflow];
      const updatedOccupants = occupants?.map(item => {
        if (
          (isMultipleUnitsFlow && item?.propertyId === occupantData.propertyId && item?.occId === occupantData.occId) ||
          (!isMultipleUnitsFlow && item?.occId === payload.occId)
        )
          return { ...occupantData };
        return item;
      });
      dispatch({
        type: types.UPDATE_OCCUPANT_SUCCESS,
        payload: { workflow, data: updatedOccupants },
      });
      return true;
    }
  } catch (err) {
    dispatch({ type: types.ADD_LEASE_PROPERTIES_ERROR, payload: err });
    return false;
  }
};

export const addOccupant = (workflow, payload, isMultipleUnitsFlow = false) => async (dispatch, getState) => {
  try {
    dispatch({ type: types.ADD_OCCUPANT });
    const { leaseReducer } = getState();
    const {
      currentStep,
      workflow: WF,
      applicationType,
      applicationStatus,
      applicationId,
      applicationNumber,
    } = leaseReducer?.[workflow];

    const stepName = WF?.steps?.find(step => step.squence === currentStep + 1)?.key;
    if (!isMultipleUnitsFlow) {
      const { occNameAr, ...apiPayload } = payload;
      await LeaseService.addOccupant({ ...apiPayload, occId: payload.occId });
      const application = await LeaseService.fetchApplicationDetails(applicationId);
      const addedOccupantRecord = application?.result?.occupants?.find(item => payload.occId === item?.occId);
      const data = {
        occId: payload.occId,
        occName: payload.occName,
        occNameAr,
        relationId: payload.relationId,
        mobileNumber: payload?.mobileNumber,
        email: payload?.email,
        id: addedOccupantRecord?.id,
      };
      dispatch({
        type: types.ADD_OCCUPANT_SUCCESS,
        payload: { workflow, data },
      });

      const relation = leaseReducer?.occupantsRelation?.result?.find(rel => rel.id === payload.relationId)?.nameE;
      CleverTapGenericServiceAddOccupantEvent({
        screenName: `screen_${applicationType}_${stepName}_view`,
        applicationStatus,
        applicationId,
        applicationNumber,
        applicationType,
        stepName,
        occupantName: payload?.occName,
        occupantNameAr: payload?.occNameAr,
        occupantRelation: relation,
        mobileNumber: payload?.mobileNumber,
        email: payload?.email,
      });
    } else if (isMultipleUnitsFlow) {
      const occupantsData = payload?.occupants?.map(occupant => ({
        occId: occupant?.occId,
        occName: occupant?.occName,
        relationId: occupant?.relationId,
        mobileNumber: occupant?.mobileNumber,
        email: occupant?.email,
      }));
      await LeaseService.addOccupant({
        applicationId: payload?.applicationId,
        propertyId: payload.propertyId,
        occupants: occupantsData,
      });

      const application = await LeaseService.fetchApplicationDetails(applicationId);

      dispatch({
        type: types.UPDATE_MULTIPLE_OCCUPANTS,
        payload: { occupants: application?.result?.occupants, workflow },
      });

      const transformedOccupants = payload?.occupants?.reduce((result, curOccupant) => {
        return {
          ...result,
          [`occupantName_${curOccupant?.occId}`]: curOccupant?.occName,
          [`occupantNameAr_${curOccupant?.occId}`]: curOccupant?.occNameAr,
          [`occupantRelation_${curOccupant?.occId}`]: leaseReducer?.occupantsRelation?.result?.find(
            rel => rel.id === curOccupant?.relationId,
          )?.nameE,
        };
      }, {});

      CleverTapGenericServiceAddOccupantEvent({
        screenName: `screen_${applicationType}_${stepName}_view`,
        applicationStatus,
        applicationId,
        applicationNumber,
        applicationType,
        stepName,
        propertyId: payload?.propertyId,
        ...transformedOccupants,
      });
    }
    return true;
  } catch (error) {
    dispatch(generalError(error));
    return false;
  }
};

export const removeOccupant = (
  workflow,
  appId,
  occId,
  oldOccupants,
  isMultipleUnitsFlow = false,
  propertyId,
) => async dispatch => {
  try {
    dispatch({ type: types.REMOVE_OCCUPANT });

    const plainId = occId?.replace(/-/g, '');
    await LeaseService.removeOccupant(`${appId}/${plainId}`, isMultipleUnitsFlow ? { propertyId } : null);

    const newOccupants = oldOccupants?.filter(occupant =>
      isMultipleUnitsFlow
        ? !(occupant.propertyId === propertyId && occupant.occId === occId)
        : occupant.occId !== occId,
    );
    if (isMultipleUnitsFlow) {
      dispatch({
        type: types.UPDATE_MULTIPLE_OCCUPANTS,
        payload: { workflow, occupants: newOccupants },
      });
    } else {
      dispatch({
        type: types.REMOVE_OCCUPANT_SUCCESS,
        payload: { workflow, newOccupants },
      });
    }
  } catch (error) {
    dispatch(generalError(error));
  }
};

export const uploadDocument = (workflow, type, body, params) => async (dispatch, getState) => {
  try {
    dispatch({ type: types.UPLOAD_LEASE_DOCUMENT });

    const document = await DocumentService.uploadDocument(body, params);

    const { leaseReducer } = getState();
    const {
      currentStep,
      workflow: WF,
      applicationType,
      applicationStatus,
      applicationId,
      applicationNumber,
    } = leaseReducer?.[workflow];
    const stepName = WF?.steps?.find(step => step.squence === currentStep + 1)?.key;
    CleverTapGenericServiceUploadDocumentEvent({
      screenName: `screen_${applicationType}_${stepName}_view`,
      applicationStatus,
      applicationId,
      applicationNumber,
      applicationType,
      stepName,
      documentType: params.documentType,
    });
    if (!document?.success) throw new Error('unable_to_upload_the_document');

    dispatch({
      type: types.UPLOAD_LEASE_DOCUMENT_SUCCESS,
      payload: { workflow, type, document },
    });
  } catch (error) {
    dispatch(generalError(error));
  }
};

export const downloadDocument = (payload, newparam = false) => async dispatch => {
  try {
    let contractName = payload?.name || null;
    if (!payload?.name) {
      contractName = messages[payload?.documentType]?.defaultmessages || 'Contract document';
    }
    dispatch({ type: types.DOWNLOAD_LEASE_DOCUMENT });
    let params = { ...payload };
    let documentPdf = null;
    if (newparam) {
      params = { ...payload, header: true };
      documentPdf = await DocumentService.downloadDocumentV2(params);
    } else {
      documentPdf = await DocumentService.downloadDocument(params);
    }

    let file = null;
    let fileURL = null;
    if (newparam) {
      fileURL = 'data:' + documentPdf?.result?.fileExtension + ';base64,' + documentPdf?.result?.bytes;
    } else {
      file = new Blob([documentPdf], { type: 'application/pdf' });
      fileURL = URL.createObjectURL(file);
    }
    const link = document.createElement('a');
    link.href = fileURL;
    if (payload?.fileName || documentPdf?.result?.filename || newparam) {
      link.setAttribute('download', documentPdf?.result?.fileName);
    } else {
      link.setAttribute('download', `${contractName || 'Contract'}.pdf`);
    }
    link.target = '_blank';
    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);

    dispatch({ type: types.DOWNLOAD_LEASE_DOCUMENT_SUCCESS });
  } catch (error) {
    dispatch(generalError(error));
  }
};

export const deleteDocument = (workflow, type, fileId, query) => async dispatch => {
  try {
    dispatch({ type: types.DELETE_LEASE_DOCUMENT });

    await DocumentService.deleteDocument(query);

    dispatch({
      type: types.DELETE_LEASE_DOCUMENT_SUCCESS,
      payload: { workflow, type, fileId },
    });
  } catch (error) {
    dispatch(generalError(error));
  }
};

export const submitApplication = (workflow, data) => async (dispatch, getState) => {
  const { leaseReducer } = getState();
  const {
    currentStep,
    workflow: WF,
    applicationType,
    applicationStatus,
    applicationId,
    applicationNumber,
  } = leaseReducer?.[workflow];
  const stepName = WF?.steps?.find(step => step.squence === currentStep + 1)?.key;
  try {
    dispatch({ type: types.SUBMIT_LEASE_APPLICATION });
    CleverTapGenericServiceNextEvent({
      screenName: `screen_${applicationType}_${stepName}_view`,
      applicationStatus,
      applicationId,
      applicationNumber,
      applicationType,
      stepName,
      ...flattenObject(data),
    });
    await LeaseService.submitApplication(
      currentStep === 0
        ? {
            ...data,
            primaryContact: leaseReducer?.[workflow]?.form?.primaryContact,
          }
        : data,
    );
    // dispatch(fetchApplicationDetails(workflow, applicationId));
    dispatch({
      type: types.SUBMIT_LEASE_APPLICATION_SUCCESS,
      payload: { workflow },
    });
    CleverTapGenericServiceNextSuccessEvent({
      screenName: `screen_${applicationType}_${stepName}_view`,
      applicationStatus,
      applicationId,
      applicationNumber,
      applicationType,
      stepName,
    });
  } catch (error) {
    dispatch(generalError(error));
    CleverTapGenericServiceNextFailureEvent({
      screenName: `screen_${applicationType}_${stepName}_view`,
      applicationStatus,
      applicationId,
      applicationNumber,
      applicationType,
      stepName,
      errorMessage: error?.data?.result?.description,
      errorCode: error?.data?.result?.statusCode,
    });
  }
};

export const checkoutApplication = (workflow, appId, data, applicationNumber = null) => async (dispatch, getState) => {
  const { leaseReducer } = getState();
  const { currentStep, workflow: WF, applicationType, applicationStatus, applicationId } = leaseReducer?.[workflow];
  const stepName = WF?.steps?.find(step => step.squence === currentStep + 1)?.key;
  try {
    dispatch({ type: types.CHECKOUT_LEASE_APPLICATION });
    CleverTapGenericServiceSubmitEvent({
      screenName: `screen_${applicationType}_${stepName}_view`,
      applicationStatus,
      applicationId,
      applicationNumber,
      applicationType,
      stepName,
    });
    await LeaseService.checkoutApplication(appId);
    CleverTapGenericServiceSubmitSuccessEvent({
      screenName: `screen_${applicationType}_${stepName}_view`,
      applicationStatus,
      applicationId,
      applicationNumber,
      applicationType,
      stepName,
    });
    history.push({
      pathname: '/app/services/lease/success',
      state: {
        ...data,
        applicationId: appId,
        applicationNumber,
        applicationType,
        applicationStatus,
      },
    });

    dispatch({
      type: types.CHECKOUT_LEASE_APPLICATION_SUCCESS,
      payload: { workflow },
    });
  } catch (error) {
    dispatch(generalError(error));
    CleverTapGenericServiceSubmitFailureEvent({
      screenName: `screen_${applicationType}_${stepName}_view`,
      applicationStatus,
      applicationId,
      applicationNumber,
      applicationType,
      stepName,
      errorMessage: error?.data?.result?.description,
      errorCode: error?.data?.result?.statusCode,
    });
  }
};

export const downloadContract = (id, name = 'Contract') => async dispatch => {
  try {
    dispatch({ type: types.DOWNLOAD_LEASE_DOCUMENT });
    const documentPdf = await LeaseService.getApplicationPDF(id);
    const file = new Blob([documentPdf], { type: 'application/pdf' });
    const fileURL = window.URL.createObjectURL(file);
    // window.open(fileURL);
    const link = document.createElement('a');

    const title = name?.defaultmessages || name;
    link.href = fileURL;
    link.setAttribute('download', `${title}.pdf`);
    link.target = '_blank';
    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);

    dispatch({ type: types.DOWNLOAD_LEASE_DOCUMENT_SUCCESS });
  } catch (error) {
    dispatch(generalError(error));
  }
};
export const downloadContractPMA = (id, name = 'Contract') => async dispatch => {
  try {
    dispatch({ type: types.DOWNLOAD_LEASE_DOCUMENT });
    const documentPdf = await LeaseService.getApplicationPDFPma(id);
    const file = new Blob([documentPdf], { type: 'application/pdf' });
    const fileURL = window.URL.createObjectURL(file);
    // window.open(fileURL);
    const link = document.createElement('a');

    const title = name?.defaultmessages || name;
    link.href = fileURL;
    link.setAttribute('download', `${title}.pdf`);
    link.target = '_blank';
    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);

    dispatch({ type: types.DOWNLOAD_LEASE_DOCUMENT_SUCCESS });
  } catch (error) {
    dispatch(generalError(error));
  }
};
export const downloadContractApplication = (id, name = 'Tenancy Contract') => async dispatch => {
  try {
    dispatch({ type: types.DOWNLOAD_LEASE_DOCUMENT });
    const documentPdf = await LeaseService.getApplicationPDFApp(id);
    const file = new Blob([documentPdf], { type: 'application/pdf' });
    const fileURL = window.URL.createObjectURL(file);

    // window.open(fileURL);
    const link = document.createElement('a');
    link.href = fileURL;
    const title = name?.defaultmessages || name;
    link.setAttribute('download', `${title}.pdf`);
    link.target = '_blank';
    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode.removeChild(link);

    dispatch({ type: types.DOWNLOAD_LEASE_DOCUMENT_SUCCESS });
  } catch (error) {
    dispatch(generalError(error));
  }
};

const responseToFormMapper = (application, edit = false, isRenewal) => {
  return {
    applicationId: application?.applicationId,
    applicationNumber: application?.applicationDetails?.applicationNumber,
    applicationType: application?.applicationDetails?.applicationType,
    applicationStatus: application?.applicationDetails?.applicationStatus,
    isMultipleUnits: application?.multipleUnit,
    application,
    form: {
      edit,
      // 1st step
      contractClassificationType: application?.parentContractId
        ? 'Commercial'
        : application?.property?.contractClassificationType,
      tenantType: application?.parentContractId ? 'Company' : application?.property?.tenantType,
      ...(!application?.multipleUnit && {
        premiseNumber: application?.property?.premiseNumber,
      }),
      premisesAddress: application?.property?.premisesAddress,
      primaryLessorObj: application?.primaryLessor,
      primaryContact: application?.primaryContact,
      primaryContactChosen: application?.primaryContact,
      lessorIsPrimaryContact: application?.primaryContact?.lessorIsPrimaryContact,
      // onwaniAddress: application?.property?.onwaniAddressGuid
      //   ? {
      //       onwaniAddressGuid: application?.property?.onwaniAddressGuid,
      //       onwaniAddressEn: application?.property?.onwaniAddressEn,
      //       onwaniAddressAr: application?.property?.onwaniAddressAr,
      //     }
      //   : !isEmpty(application?.onwaniAddressDetail)
      //   ? application?.onwaniAddressDetail
      //   : application?.selectedPlotIds?.[0]?.buildingClassificationEn?.toLowerCase() === 'villa'
      //   ? application?.selectedPlotIds
      //   : null,

      // 2nd step - for renewal & modification
      secondPartyMissing: application?.secondPartyMissing,

      // 2nd step - Person
      ...(application?.individual?.eidNumberOrUnified && {
        eidNumberOrUnified: application?.individual?.eidNumberOrUnified,
      }),
      ...(application?.individual?.tenEmail && {
        tenEmail: application?.individual?.tenEmail,
      }),
      ...(application?.individual?.tenName && {
        tenName: application?.individual?.tenName,
      }),
      ...(application?.individual?.tenNameAr && {
        tenNameAr: application?.individual?.tenNameAr,
      }),
      ...(application?.individual?.tenPhone && {
        tenPhone: application?.individual?.tenPhone,
      }),
      ...(application?.individual?.businessFlags && {
        businessFlags: application?.individual?.businessFlags,
      }),
      ...(application?.occupants && { occupants: application?.occupants }),

      // 2nd step - Company || Government
      ...(application?.company?.compEmail && {
        compEmail: application?.company?.compEmail,
      }),
      ...(application?.company?.compPhone && {
        compPhone: application?.company?.compPhone,
      }),
      ...(application?.company?.companyName && {
        companyName: application?.company?.companyName,
      }),
      ...(application?.company?.companyNameAr && {
        companyNameAr: application?.company?.companyNameAr,
      }),
      ...(application?.company?.repId && {
        repId: application?.company?.repId,
      }),
      ...(application?.company?.repName && {
        repName: application?.company?.repName,
      }),
      ...(application?.company?.repNameAr && {
        repNameAr: application?.company?.repNameAr,
      }),
      ...(application?.company?.repEmail && {
        repEmail: application?.company?.repEmail,
      }),
      ...(application?.company?.repPhone && {
        repPhoneNumber: application?.company?.repPhone,
      }),
      ...(application?.company?.tradeLicenseNo && {
        tradeLicenseNo: application?.company?.tradeLicenseNo,
      }),
      ...(application?.company?.businessFlags && {
        businessFlags: application?.company?.businessFlags,
      }),

      // 2nd step - Multiple Occupants
      // 2nd step - Person + Commercial
      ...(application?.reserve?.reserveName && {
        reserveName: application?.reserve?.reserveName,
      }),
      ...(application?.reserve?.tradeLicenseNo && {
        reserveNo: application?.reserve?.tradeLicenseNo,
      }),
      moreThanOneYear: application?.moreThanOneYear,

      // 2nd step - Diplomat + Embassy
      ...(application?.diplomatic && !isEmpty(application?.company) && { diplomatType: 'embassy' }),
      ...(application?.diplomatic &&
        !isEmpty(application?.individual) && {
          diplomatType: 'Person',
          diplomatId: application?.individual?.eidNumberOrUnified,
        }),

      // 3rd step
      contStartDate: isRenewal
        ? addDays(new Date(application?.rental?.actualContractEndDate), 1)
        : application?.rental?.contStartDate,
      contEndDate: isRenewal ? '' : application?.rental?.contEndDate,
      deposit: application?.rental?.deposit || 0,
      gracePeriod: isRenewal ? 0 : application?.rental?.gracePeriod,
      adwaBillType: application?.rental?.adwaBillType ? application?.rental?.adwaBillType : 'TENANT',
      noOfInstallments: application?.rental?.noOfInstallments,
      paymentMethod: application?.rental?.paymentMethod,
      totalAmount: application?.rental?.totalAmount,
      annualRentAmount: application?.rental?.annualRentAmount,
      allowTenantSublease: application?.rental?.allowTenantSublease,
      isPetAllowed: application?.rental?.isPetAllowed,
      showMultipleLicense: application?.showMultipleLicense,
      multipleLicenseAllowed: application?.rental?.multipleLicenseAllowed,

      // 4th step
      appendix: application?.appendix,
      appendixList: application?.appendixList,
      LEASE_OTHERS: application?.documents?.filter(doc => doc.type === 'LEASE_OTHERS'),
      LEASE_DIPLOMAT: application?.documents?.filter(doc => doc.type === 'LEASE_DIPLOMAT'),
      COMMERCIAL_ACTIVITY_PERMIT: application?.documents?.filter(doc => doc.type === 'COMMERCIAL_ACTIVITY_PERMIT'),
      TOWN_PLANNING_APPROVAL: application?.documents?.filter(doc => doc.type === 'TOWN_PLANNING_APPROVAL'),
      PUBLIC_BENEFIT_ASSOCIATION: application?.documents?.filter(doc => doc.type === 'PUBLIC_BENEFIT_ASSOCIATION'),
      EXCEPTIONAL_ADDING_OCCUPANT: application?.documents?.filter(doc => doc.type === 'EXCEPTIONAL_ADDING_OCCUPANT'),
    },
  };
};

export const initiateRegEditProcess = application => async dispatch => {
  try {
    let applicationContent = application;
    if (application?.drfatId) {
      // fetch application
      const response = await LeaseApplicationService.fetchLeaseApplication(application?.drfatId);
      const res = response?.data?.result || response?.result;
      // document
      const documents = await fetchDocument(application?.drfatId);

      // property
      if (res?.multipleUnit !== true) {
        const propertyDetail = await fetchPropertyDetail(res?.property?.plotId);
        res.propertyDetail = propertyDetail;
      }
      res.documents = documents;
      applicationContent = res;
    }

    const editData = responseToFormMapper(
      applicationContent,
      true,
      applicationContent?.applicationDetails?.applicationType === 'LEASE_RENEWAL',
    );

    // let onwaniAddressRes;
    let property;
    let isVilla;
    // if (editData?.isMultipleUnits === true) {
    //   if (editData?.application?.selectedPlotIds?.[0]?.buildingClassificationEn?.toLowerCase() === 'villa') {
    //     // ! calling onwani address API in case villa
    //     onwaniAddressRes = await LeaseService.getOnwaniAddresses(
    //       editData?.application?.selectedPlotIds?.map(prop => prop?.plotId),
    //     );
    //     isVilla = true;
    //   } else {
    //     onwaniAddressRes = await LeaseService.getOnwaniAddress(applicationContent?.selectedPlotIds?.[0]?.plotId);
    //     isVilla = false;
    //   }
    // } else {
    //   property = await PropertiesService.fetchPropertyLease(applicationContent?.property?.plotId);
    //   onwaniAddressRes = await LeaseService.getOnwaniAddress(applicationContent?.property?.plotId);
    // }
    if (editData?.isMultipleUnits !== true) {
      property = await PropertiesService.fetchPropertyLease(applicationContent?.property?.plotId);
      // onwaniAddressRes = await LeaseService.getOnwaniAddress(applicationContent?.property?.plotId);
    }
    let actionType = '';
    let url = '';
    if (applicationContent?.applicationType === 'LEASE_RENEWAL') {
      actionType = types.SET_LEASE_RENEWAL_FORM;
      url = `/app/services/lease-renewal/${application?.drfatId || application?.applicationId}`;
    } else if (applicationContent?.applicationType === 'LEASE_AMENDMENT') {
      actionType = types.SET_LEASE_AMENDMENT_FORM;
      url = `/app/services/lease-variation/${application?.drfatId || application?.applicationId}`;
    } else {
      actionType = types.SET_LEASE_REGISTRATION_FORM;
      url = `/app/services/lease/registration/${application?.drfatId || application?.applicationId}`;
    }

    dispatch({
      type: actionType,
      payload: {
        form: editData.form,
        subleasePermissions: {
          allowSubContract: editData.application.allowSubContract,
          subleaseOwnerApprovalRequired: editData.application.subleaseOwnerApprovalRequired,
          clearSubleaseAgreement: editData.application.clearSubleaseAgreement,
        },
        application: editData.application,
        applicationId: editData.applicationId,
        applicationNumber: editData.applicationNumber,
        applicationStatus: editData.applicationStatus,
        isMultipleUnits: editData.isMultipleUnits,
        property,
        // onwaniAddress: onwaniAddressRes?.result,
        isVilla,
      },
    });
    history.push({
      pathname: url,
      state: {
        property: applicationContent.propertyDetail?.en,
        applicationNum: editData.applicationNumber,
      },
      search:
        '?applicationId=' +
        editData.applicationNumber +
        `${!applicationContent?.multipleUnit ? '&propertyId=' + property?.result?.propertyID : ''}` +
        '&applicationType=' +
        applicationContent?.applicationType +
        '&multipleUnit=' +
        !!applicationContent?.multipleUnit,
    });
  } catch (error) {
    dispatch({
      type: types.SET_LEASE_FORM_ERROR,
      payload: error,
    });
  }
};

export const fetchLeaseContracts = (body, params) => async dispatch => {
  try {
    dispatch({ type: types.FETCH_LEASE_CONTRACTS });

    const contracts = await LeaseService.fetchContracts(body, params);
    const amendmentFee = await LeaseService.fetchAmendmentFee();

    dispatch({
      type: types.FETCH_LEASE_CONTRACTS_SUCCESS,
      payload: { contracts, amendmentFee },
    });
  } catch (error) {
    dispatch(generalError(error));
  }
};

export const fetchAmendmentFee = () => async dispatch => {
  try {
    dispatch({ type: types.FETCH_AMENDMENT_FEE });

    const amendmentFee = await LeaseService.fetchAmendmentFee();

    dispatch({
      type: types.FETCH_AMENDMENT_FEE_SUCCESS,
      payload: { amendmentFee },
    });
  } catch (error) {
    dispatch(generalError(error));
  }
};

export const initRenewalAmendmentApp = (
  key,
  workflowId,
  data,
  propertyId = null,
  isMultiUnit = false,
) => async dispatch => {
  try {
    dispatch({ type: types.INITIATE_RENEWAL_AMENDMENT_APPLICATION });
    let appType = 'LEASE_RENEWAL';
    if (key === 'amendment') {
      appType = 'LEASE_AMENDMENT';
    }
    const validationParams = {
      applicationType: appType,
      contractId: data?.contractId,
      // ...(isMultiUnit !== true && {
      //   plotId: propertyId,
      // }),
    };
    const validation = await WorkflowService.checkValidation(validationParams);
    if (!isEmpty(validation?.result)) {
      CleverTapServicesPreValidation({
        property_id: propertyId,
        application_type: appType,
        contractId: data?.contractId,
        ...formatPreValidationForClevertap(validation?.result),
      });

      if (isMultiUnit === true) {
        history.push('/app/services/lease/multi-units-validations', {
          data: validation?.result,
          plotIds: propertyId,
          isRenewalOrAmendment: true,
        });
      } else {
        history.push('/app/services/validations', { ...validation?.result });
      }
      dispatch({
        type: types.INITIATE_LEASE_APPLICATION_FAILURE,
      });
      return;
    }
    CleverTapServicesPreValidation({
      property_id: propertyId,
      application_type: appType,
      contractId: data?.contractId,
    });
    CleverTapServicesStartApplication({
      property_id: propertyId,
      application_type: appType,
    });
    const initiate = await WorkflowService.registerApplication(data);
    const workflow = await WorkflowService.fetchWorkflow(workflowId);

    workflow?.result?.attributes
      ?.find(item => item.name === 'contractClassificationType')
      ?.values.push(
        {
          selected: false,
          id: 125385849115547,
          valueId: 'DiplomaticOffices',
          valueName: 'diplomat',
        },
        {
          selected: false,
          id: 125385849115548,
          valueId: 'Government',
          valueName: 'government',
        },
        {
          selected: false,
          id: 125385849115549,
          valueId: 'PublicBenefitAssociation',
          valueName: 'public_benefit_association',
        },
      );

    if (!initiate?.result?.id || !initiate?.result?.propertyId) throw new Error('unable_to_initiate_the_application');
    const isMultipleUnits = initiate?.result?.multipleUnit;
    const application = await LeaseService.fetchApplicationDetails(initiate?.result?.id);
    const documents = await DocumentService.fetchApplicationDocuments({
      applicationId: initiate?.result?.id,
    });

    const formData = responseToFormMapper(
      { ...application.result, documents: documents.result },
      false,
      key === 'renewal',
    );

    let property;

    if (!isMultipleUnits) {
      property = await LeaseService.fetchProperty(initiate?.result?.propertyId);
    }

    // const onwaniAddressRes = await LeaseService.getOnwaniAddress(initiate?.result?.propertyId);

    if (appType === 'LEASE_RENEWAL') CleverTapServicesLeaseRenewalInitiateFlow();
    if (appType === 'LEASE_AMENDMENT') CleverTapServicesLeaseAmendmentInitiateFlow();
    dispatch({
      type: types.INITIATE_RENEWAL_AMENDMENT_APPLICATION_SUCCESS,
      payload: {
        key,
        workflow,
        applicationId: initiate?.result?.id,
        application,
        formData,
        property,
        // onwaniAddress: onwaniAddressRes?.result,
        isMultipleUnits,
      },
    });
    const newTypeMaps = {
      amendment: 'variation',
      renewal: 'renewal',
      closure: 'expiration',
      cancellation: 'surrender',
      'termination-court-order': 'termination-court-order',
    };
    history.replace({
      pathname: `/app/services/lease-${newTypeMaps[key]}/${initiate?.result?.id}`,
      // state: { property: { ...data, propertyId: selected?.propertyId } },
    });
  } catch (error) {
    dispatch(generalError(error));
  }
};

export const resetApplication = workflow => async dispatch => {
  dispatch({ type: types.RESET_LEASE_APPLICATION, payload: { workflow } });
};

export const discardApplication = (workflow, id) => async dispatch => {
  try {
    dispatch({ type: types.DISCARD_LEASE_APPLICATION });

    await WorkflowService.cancelApplication(id);
    dispatch({
      type: types.DISCARD_LEASE_APPLICATION_SUCCESS,
      payload: { workflow },
    });

    history.replace('/app/services?slug=lease');
    return true;
  } catch (error) {
    dispatch(generalError(error));
    return error?.message;
  }
};

export const fetchOccupant = (id, params) => async dispatch => {
  try {
    dispatch({ type: types.FETCH_LEASE_OCCUPANT });

    const occupant = await OwnerService.fetchUserById(id, params);
    dispatch({ type: types.FETCH_LEASE_OCCUPANT_SUCCESS, occupant });
    return occupant;
  } catch (error) {
    dispatch(generalError(error));
    return error;
  }
};
export const fetchOccupantRelations = id => async dispatch => {
  try {
    const occupantRelations = await LeaseService.fetchOccupantRelation(id);

    dispatch({
      type: types.FETCH_OCCUPANT_RELATIONS,
      payload: occupantRelations,
    });
    return occupantRelations;
  } catch (error) {
    dispatch(generalError(error));
    return error;
  }
};
export const uploadClosureDocument = (body, params) => async dispatch => {
  try {
    dispatch({ type: types.UPLOAD_LEASE_CLOSURE_DOCUMENT });

    const document = await DocumentService.uploadDocument(body, params);

    dispatch({ type: types.UPLOAD_LEASE_CLOSURE_DOCUMENT_SUCCESS });
    return document;
  } catch (error) {
    dispatch(generalError(error));
    return error;
  }
};

export const deleteClosureDocument = (subType, query, uploadedDocuments) => async dispatch => {
  try {
    dispatch({ type: types.UPLOAD_LEASE_CLOSURE_DOCUMENT });

    await DocumentService.deleteDocument(query);

    const newDocuments = uploadedDocuments.filter(doc => doc.subType !== subType);

    dispatch({ type: types.UPLOAD_LEASE_CLOSURE_DOCUMENT_SUCCESS });
    return { success: true, result: newDocuments };
  } catch (error) {
    dispatch(generalError(error));
    return error;
  }
};
export const errorDiscard = () => async dispatch => {
  dispatch(generalError({ message: '' }));
};

export const addLeaseProperties = payload => async dispatch => {
  try {
    dispatch({ type: types.ADD_LEASE_PROPERTIES });
    const validationParams = {
      applicationType: 'LEASE_REGISTRATION',
      applicationId: payload?.applicationId,
      plotIds: [...payload?.plotIds],
    };
    const validation = await WorkflowService.checkPostValidation(validationParams);
    if (!isEmpty(validation?.result)) {
      dispatch({ type: types.ADD_LEASE_PROPERTIES_VALIDATION_ERROR });
      history.replace('/app/services/lease/multi-units-validations', {
        data: validation?.result,
        applicationId: payload?.applicationId,
        // plotIds: payload?.plotIds,
      });
    } else {
      const leaseAddProperty = await LeaseService.addLeaseProperties(payload);
      if (leaseAddProperty?.success) {
        dispatch({ type: types.ADD_LEASE_PROPERTIES_SUCCESS });
        history.push({
          pathname: `/app/services/lease/registration/${payload?.applicationId}`,
          state: { applicationNum: payload?.applicationId },
        });
        return true;
      }
    }

    return false;
  } catch (err) {
    dispatch({ type: types.ADD_LEASE_PROPERTIES_ERROR, payload: err });
    // eslint-disable-next-line consistent-return
    return false;
  }
};

export const fetchLeasableProperties = payload => async dispatch => {
  try {
    dispatch({ type: types.FETCH_LEASABLE_PROPERTIES });
    const response = await PropertiesService.fetchLeaseProperties(payload);
    dispatch({ type: types.FETCH_LEASABLE_PROPERTIES_SUCCESS });
    return response;
  } catch (err) {
    dispatch({ type: types.FETCH_LEASABLE_PROPERTIES_ERROR, payload: err });
    return { success: false };
  }
};

export const fetchPlots = appId => async dispatch => {
  try {
    dispatch({ type: types.FETCH_PLOTS });

    const res = await LeaseService.fetchApplicationDetails(appId);
    dispatch({ type: types.FETCH_PLOTS_SUCCESS });
    if (res?.success) {
      const { selectedPlotIds } = res?.result;
      return isArray(selectedPlotIds) && !isEmpty(selectedPlotIds) ? selectedPlotIds?.map(unit => unit?.plotId) : [];
    }
    return [];
  } catch (error) {
    dispatch(generalError(error));
    return [];
  }
};

export const removeUnit = (workflow, applicationId, plotId, oldPropertyUnits) => async dispatch => {
  try {
    dispatch({ type: types.REMOVE_UNIT });

    if (oldPropertyUnits?.length === 1) {
      dispatch({ type: types.REMOVE_LAST_UNIT });
    } else {
      const res = await LeaseService.removeUnit({
        applicationId,
        plotIds: [plotId],
      });
      if (res?.success) {
        const newPropertyUnits = oldPropertyUnits?.filter(unit => unit?.plotId !== plotId);
        dispatch({
          type: types.REMOVE_UNIT_SUCCESS,
          payload: { workflow, newPropertyUnits },
        });
      }
    }
  } catch (error) {
    dispatch(generalError(error));
  }
};

export const toggleDialogueCancel = dialogueStatus => async dispatch => {
  dispatch({ type: types.TOGGLE_DIALOGUE_CANCEL, payload: { dialogueStatus } });
};

// export const fetchMultipleOccupants = id => async dispatch => {
//   try {
//     dispatch({ type: types.FETCH_LEASE_OCCUPANT });

//     const occupant = await LeaseService.fetchUserByIdLease(id);

//     dispatch({ type: types.FETCH_LEASE_OCCUPANT_SUCCESS, occupant });
//     return occupant;
//   } catch (error) {
//     dispatch(generalError(error));
//     return error;
//   }
// };

export const getSelectedProperties = applicationId => async dispatch => {
  try {
    dispatch({ type: types.FETCH_SELECTED_PROPERTIES });

    const res = await LeaseService.getSelectedProperties({
      size: 100,
      page: 0,
      applicationId,
    });

    res?.success &&
      dispatch({
        type: types.FETCH_SELECTED_PROPERTIES_SUCCESS,
        payload: { selectedProperties: res?.result?.properties },
      });
  } catch (error) {
    dispatch(generalError(error));
  }
};

export const fetchContractAmount = data => async dispatch => {
  try {
    const response = await LeaseService.getContractAmount(data);
    dispatch({
      type: types.LEASE_FETCH_CONTRACT_AMOUNT,
      payload: response?.result,
    });
    return response?.result;
  } catch (error) {
    dispatch(generalError(error));
    return error;
  }
};
const loading = () => ({
  type: types.LEASE_SERVICE_ACTION_START,
});
const success = () => ({
  type: types.LEASE_SERVICE_ACTION_SUCCESS,
});
export const previewLeaseContract = appId => async dispatch => {
  try {
    dispatch(loading());
    const res = await LeaseService.previewLeaseContract(appId);
    dispatch(success());
    return res;
  } catch (error) {
    dispatch(generalError(error));
    return false;
  }
};
export const downloadContractPdf = (documentPdf, title) => {
  const file = new Blob([documentPdf], { type: 'application/pdf' });
  const fileURL = URL.createObjectURL(file);

  const link = document.createElement('a');
  link.href = fileURL;
  link.setAttribute('download', title);
  link.target = '_blank';

  document.body.appendChild(link);

  link.click();

  link.parentNode.removeChild(link);
};

export const setAllowSubContract = payload => dispatch => {
  dispatch({ type: types.SET_ALLOW_SUB_CONTRACT, payload });
};
export const setIsOwnerApprovalRequired = payload => dispatch => {
  dispatch({ type: types.SET_IS_OWNER_APPROVAL_REQUIRED, payload });
};

export const setAllowClearSubleaseAgreement = payload => dispatch => {
  dispatch({ type: types.TRANSFER_OF_INTEREST_SET_MORTGAGE_BANK_MAKER_DETAILS, payload });
};

export const setSubleasePermissions = ({ workflowId, ...payload }) => dispatch => {
  dispatch({
    type: types.SET_SUB_LEASE_PERMISSIONS,
    payload: {
      permissions: payload,
      workflow: workflowId,
    },
  });
};

export const fetchRepresentativeDetails = ({ workflow, eidNumber }) => async dispatch => {
  dispatch({ type: types.FETCH_REPRESENTATIVE_DETAILS_LOADING });

  try {
    const response = await OwnerService.fetchUserById(eidNumber);

    const payload = {
      workflow,
      data: {
        repId: response?.result?.eid,
        repName: response?.result?.nameEn,
        repNameAr: response?.result?.nameAr,
        repEmail: response?.result?.email,
        repPhoneNumber: response?.result?.phoneNumber,
      },
    };
    dispatch({ type: types.FETCH_REPRESENTATIVE_DETAILS_SUCCESS, payload });
  } catch (error) {
    dispatch({ type: types.FETCH_REPRESENTATIVE_DETAILS_ERROR, payload: error });
  }
};
